module.exports = __webpack_public_path__ + "static/media/placeholder.ddce5b97.svg";